import React from 'react';
import { Link } from 'react-router-dom';
import '../Legal.css';

function PrivacyPolicy() {
  return (
    <div className="legal-page">
      <div className="legal-container">
        <Link to="/" className="back-link">← Вернуться на главную</Link>
        
        <h1>ПОЛИТИКА В ОТНОШЕНИИ ОБРАБОТКИ ПЕРСОНАЛЬНЫХ ДАННЫХ</h1>
        
        <div className="legal-info">
          <p><strong>Постоянный адрес публикации:</strong> https://duh-prim.ru/privacy-policy</p>
          <p><strong>Дата публикации:</strong> {new Date().toLocaleDateString('ru-RU')}</p>
        </div>

        <section>
          <h2>1. ОБЩИЕ ПОЛОЖЕНИЯ</h2>
          <p><strong>1.1.</strong> Настоящая Политика определяет порядок обработки и защиты персональных данных граждан, 
          пользующихся услугами интернет-магазина https://duh-prim.ru (далее — Сайт).</p>
          
          <p><strong>1.2.</strong> Оператором персональных данных является Индивидуальный предприниматель 
          Бурков Максим Артурович (ИНН 250822172828, ОГРНИП 325253600073026), зарегистрированный по адресу: 
          Приморский край, г. Находка (далее — Оператор).</p>
          
          <p><strong>1.3.</strong> Использование Сайта и оформление заказа означает безоговорочное согласие 
          Пользователя с настоящей Политикой и условиями обработки его персональных данных.</p>
        </section>

        <section>
          <h2>2. ЦЕЛИ СБОРА ДАННЫХ</h2>
          <p className="intro">Оператор собирает и обрабатывает персональные данные Пользователя для следующих целей:</p>
          
          <p><strong>2.1.</strong> <strong>Исполнение договора купли-продажи:</strong> обработка, комплектация и отправка заказов клиенту.</p>
          
          <p><strong>2.2.</strong> <strong>Доставка:</strong> передача необходимых данных транспортным компаниям и курьерским службам для вручения товара.</p>
          
          <p><strong>2.3.</strong> <strong>Связь с клиентом:</strong> уточнение деталей заказа, информирование о статусе доставки, ответы на запросы и претензии.</p>
          
          <p><strong>2.4.</strong> <strong>Улучшение качества обслуживания:</strong> анализ работы Сайта (через файлы cookie).</p>
        </section>

        <section>
          <h2>3. ОБЪЕМ ОБРАБАТЫВАЕМЫХ ДАННЫХ</h2>
          <p><strong>3.1.</strong> Для выполнения целей, указанных в п. 2, Оператор обрабатывает следующие персональные данные Пользователя:</p>
          
          <div className="warning">
            <ul>
              <li>Фамилия, Имя, Отчество</li>
              <li>Контактный телефон</li>
              <li>Адрес электронной почты (e-mail)</li>
              <li>Адрес доставки товара</li>
            </ul>
          </div>
          
          <p><strong>3.2.</strong> Также на Сайте происходит сбор и обработка обезличенных данных о посетителях 
          (в т.ч. файлов «cookie») с помощью сервисов интернет-статистики (Яндекс Метрика и других).</p>
        </section>

        <section>
          <h2>4. ПОРЯДОК ОБРАБОТКИ И ПЕРЕДАЧА ДАННЫХ ТРЕТЬИМ ЛИЦАМ</h2>
          <p><strong>4.1.</strong> Обработка персональных данных осуществляется как автоматизированным, так и неавтоматизированным способами.</p>
          
          <p><strong>4.2.</strong> Оператор обеспечивает конфиденциальность персональных данных.</p>
          
          <p><strong>4.3.</strong> <strong>Передача данных третьим лицам:</strong> Пользователь соглашается с тем, что Оператор 
          вправе передавать его персональные данные третьим лицам исключительно в целях выполнения заказа, в частности:</p>
          
          <div className="warning">
            <ul>
              <li>Курьерским службам</li>
              <li>Организациям почтовой связи (Почта России)</li>
              <li>Операторам электросвязи</li>
            </ul>
          </div>
          
          <p><strong>4.4.</strong> Передача данных государственным органам осуществляется только в порядке, установленном законодательством РФ.</p>
        </section>

        <section>
          <h2>5. ЗАЩИТА ПЕРСОНАЛЬНЫХ ДАННЫХ</h2>
          <p><strong>5.1.</strong> Оператор принимает необходимые правовые, организационные и технические меры для защиты 
          персональных данных от неправомерного или случайного доступа к ним, уничтожения, изменения, блокирования, 
          копирования, предоставления, распространения, а также от иных неправомерных действий.</p>
        </section>

        <section>
          <h2>6. СРОКИ ОБРАБОТКИ И ОТЗЫВ СОГЛАСИЯ</h2>
          <p><strong>6.1.</strong> Обработка персональных данных осуществляется до момента отписки Пользователя или 
          до момента, когда цель обработки достигнута (заказ выполнен и гарантийный срок истек).</p>
          
          <p><strong>6.2.</strong> Пользователь может в любой момент отозвать свое согласие на обработку персональных данных. 
          Для этого необходимо направить уведомление на электронную почту Оператора: 
          <a href="mailto:duh_primorye@mail.ru">duh_primorye@mail.ru</a> с пометкой «Отзыв согласия на обработку персональных данных».</p>
          
          <p><strong>6.3.</strong> В случае отзыва согласия Оператор прекращает обработку данных и уничтожает их, 
          за исключением случаев, когда сохранение данных требуется по закону (например, для бухгалтерской отчетности).</p>
        </section>

        <section>
          <h2>7. ЗАКЛЮЧИТЕЛЬНЫЕ ПОЛОЖЕНИЯ</h2>
          <p><strong>7.1.</strong> Актуальная версия Политики находится в свободном доступе в сети Интернет по адресу: 
          <a href="https://duh-prim.ru/privacy-policy" target="_blank" rel="noopener noreferrer">https://duh-prim.ru/privacy-policy</a>.</p>
          
          <p><strong>7.2.</strong> Оператор имеет право вносить изменения в настоящую Политику. Новая редакция 
          вступает в силу с момента ее размещения.</p>
        </section>

        <section className="contacts">
          <h2>8. КОНТАКТНЫЕ ДАННЫЕ ОПЕРАТОРА</h2>
          <div className="contact-info">
            <div className="contact-details">
            <h3>ИП Бурков Максим Артурович</h3>
            <p>Адрес: Приморский край, г. Находка</p>
            <p>ИНН: 250822172828</p>
            <p>ОГРНИП: 325253600073026</p>
            </div>
            
            <div className="contact-details">
              <h3>Контакты:</h3>
              <p>📞 <a href="tel:+79915376731">+7 (991) 537-67-31</a></p>
              <p>📞 <a href="tel:+79940081324">+7 (994) 008-13-24</a></p>
              <p>📧 <a href="mailto:duh_primorye@mail.ru">duh_primorye@mail.ru</a></p>
            </div>
          </div>
        </section>
      </div>
    </div>
  );
}

export default PrivacyPolicy;
